import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { RankingFilterOption } from '../models/ranking-filter-models';
import { RankingPage, RankingUserDetail } from '../models/ranking-models';

/**
 * Events of the global ranking region, including the server-driven filter options and
 * the per-user detail lookup behind the profile modal.
 */
export const rankingEvents = eventGroup({
  source: 'Ranking',
  events: {
    loadRankingFilterOptions: type<void>(),
    loadRankingFilterOptionsSuccess: type<{ options: RankingFilterOption[] }>(),
    loadRankingFilterOptionsFailed: type<{ error: string }>(),
    /** Picks the option whose ranking is shown; the store loads that ranking in turn. */
    selectFilterOption: type<{ option: RankingFilterOption }>(),
    loadRanking: type<{ filterOption: RankingFilterOption }>(),
    loadRankingSuccess: type<{ ranking: RankingPage }>(),
    loadRankingFailed: type<{ error: string }>(),
    // `isCurrentUser` is carried for tenant features that react to this event — e.g. the
    // Effzeh season store, which only fetches the (public) season answers of OTHER users.
    loadRankingUserDetail: type<{ userId: string; isCurrentUser: boolean }>(),
    loadRankingUserDetailSuccess: type<{ detail: RankingUserDetail }>(),
    loadRankingUserDetailFailed: type<{ error: string }>(),
  },
});
